import { browser } from "$app/environment";
import { showToast } from "@cf/ui-lib/utils";
import { createMutation, createQuery, type CreateMutationOptions, type MutationFunction, type QueryFunction, type QueryKey, type StoreOrVal, type UndefinedInitialDataOptions } from "@tanstack/svelte-query";
import { writable } from "svelte/store";

export const simpleCreateQuery = (queryKey: any[],
    callback: QueryFunction<any, QueryKey, never>,
    options?: StoreOrVal<UndefinedInitialDataOptions<any, Error, any, QueryKey>>
) => {
    return createQuery<any, Error>({
        queryKey,
        enabled: browser,
        queryFn: async (...args) => {
            try {
                const result = await callback(...args);
                return result;
            }
            catch (ex: any) {
                if (["FST_JWT_BAD_REQUEST", "AUTHENTICATION_ERROR"].includes(ex?.response?.data?.code) && window?.location?.href) {
                    window.location.href = '/auth';
                }
                const redirectSudomain = ex?.response?.data?.redirect;
                if (redirectSudomain) {
                    const url = new URL(window.location.href);
                    const currentSubdomain = url.hostname?.split('.')?.[0];
                    window.location.href = `${ url.origin?.replace(currentSubdomain, redirectSudomain) }/uilib/listings`;
                }
                showToast({ title: 'Error', description: ex?.response?.data?.error || ex.message || "Something went wrong", type: 'error' });
                console.error("Query error", ex);
                return null;
            }
        },
        ...(options || {})
    });
};

export const simpleCreateMutation = <ArgsType, RetType = unknown>(
    callback: MutationFunction<RetType, ArgsType>,
    options?: CreateMutationOptions<RetType, unknown, ArgsType, unknown>
) => {
    const resultFunction = browser ? async (data: ArgsType) => {
        try {
            const result = await callback(data);
            return result;
        }
        catch (ex: any) {
            if (["FST_JWT_BAD_REQUEST", "AUTHENTICATION_ERROR"].includes(ex?.response?.data?.code) && window?.location?.href) {
                window.location.href = '/auth';
            }
            const redirectSudomain = ex?.response?.data?.redirect;
            if (redirectSudomain) {
                const url = new URL(window.location.href);
                const currentSubdomain = url.hostname?.split('.')?.[0];
                window.location.href = `${ url.origin?.replace(currentSubdomain, redirectSudomain) }/uilib/listings`;
            }
            console.error("Mutation error", ex?.response?.data?.error);
            showToast({ title: 'Error', description: ex?.response?.data?.error || ex.message || "Something went wrong", type: 'error' });
            return null as RetType;
        }
    } : (async () => writable({}) as RetType);

    return createMutation<RetType, unknown, ArgsType>({
        mutationFn: resultFunction,
        ...(options || {})
    });
};